import styled from 'styled-components';
import { sizes } from '../../theme';
import CheckboxInput, { TextBlock } from './CheckboxInput';
import { FlexColMd } from 'components/Elements';

export type CheckboxOption = {
    name: string;
    value: string;
    inputProps: object;
    unfocusable?: boolean;
};

export default function Checkboxes({ options }: { options: CheckboxOption[] }): JSX.Element {
    return (
        <FlexColMd>
            {options &&
                options.map((option, index) => (
                    <OptionContainer key={index}>
                        <CheckboxContainer>
                            <CheckboxInput
                                id={option.value}
                                name={option.name}
                                value={option.value}
                                unfocusable={option.unfocusable}
                                aria={`Check: ${option.value}.`}
                                {...option.inputProps}
                            />
                        </CheckboxContainer>
                        <TextBlock htmlFor={option.value}>{option.name}</TextBlock>
                    </OptionContainer>
                ))}
        </FlexColMd>
    );
}

const OptionContainer = styled.div`
    position: relative;
    max-width: 640px;
    align-items: center;
`;

const CheckboxContainer = styled.div`
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-left: ${sizes.spacingMd};
`;
